import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "external", "onClick"];
import { useState } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import ServiceEvaluationSlideshowModal from '../../modal/ServiceEvaluationSlideshowModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ServiceEvaluationSlideshowLink = _ref => {
  let {
      children,
      onClick = () => {}
    } = _ref,
    remainingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [showServiceEvaluationModal, setShowServiceEvaluationModal] = useState(false);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Link, Object.assign({
      onClick: event => {
        setShowServiceEvaluationModal(true);
        onClick(event);
      }
    }, remainingProps, {
      children: children
    })), showServiceEvaluationModal && /*#__PURE__*/_jsx(ServiceEvaluationSlideshowModal, {
      onClose: () => {
        setShowServiceEvaluationModal(false);
      }
    })]
  });
};
export default ServiceEvaluationSlideshowLink;